import { useEffect, useState } from 'react';
import { InputField, type InputFieldProps } from '#components/Input/Text/InputField';

export default function DebouncedInput({
  value: initialValue,
  onChange,
  debounce = 500,
  ...props
}: {
  value: string | number;
  onChange: (value: string | number) => void;
  debounce?: number;
} & InputFieldProps) {
  const [value, setValue] = useState(initialValue);

  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      onChange(value);
    }, debounce);

    return () => {
      clearTimeout(timeout);
    };
  }, [debounce, onChange, value]);

  return (
    <InputField
      {...props}
      slim={true}
      value={value}
      onChange={(e) => {
        setValue(e.target.value);
      }}
    />
  );
}
